import axios from 'axios'
const service = axios.create({
  baseURL: process.env.VUE_APP_SAVITARNA_GLOBAL_URL,
  timeout: 50000, // timeout,
})

export default service
